export class Firma_Electronica_CamposEnviar {
    campo: string;
    valor: string;
    descripcion: string;
    tipoCampo: string;
}